



















































































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { isNull } from 'lodash';

import PaginationInterface from '@core/interfaces/pagination-interface';
import { BPCDisplayConfig } from '@core/interfaces/bpc-display-config';
import { paymentDisplayFields, paymentFilters } from '@/config/subscriptions';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';

import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import TableWrapper from '@shared/layouts/wrappers/table/table-wrapper.vue';
import GridMock from '@shared/components/mocks/grid-mock/grid-mock.vue';

import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import SearchInput from '@shared/components/forms/inputs/search-input.vue';

import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
// import MembershipForm from '@subscriptions/components/forms/admin/membership-form.vue';
import moment from 'moment';
import Table from '@shared/components/tables/table.vue';
import MembershipPaymentForm from '@subscriptions/components/forms/admin/membership-payment-form.vue';
import { MembershipCategory } from '@subscriptions/interfaces/subscription-category';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';
import DisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import DisplayFieldCode from '@shared/components/displays/display-field-code/display-field-code.vue';
import DisplayContactLink from '@shared/components/displays/display-contact-link/display-contact-link.vue';
import { Payment } from '@accounting/interfaces/payment';

@Component({
  name: 'bpc-membership-list',
  components: {
    'bpc-content-wrapper': ContentWrapper,
    'bpc-table-wrapper': TableWrapper,
    'bpc-grid-mock': GridMock,
    'bpc-entity-select': EntitySelect,
    'bpc-multi-select': MultiSelect,
    'bpc-search-input': SearchInput,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-table': Table,
    'bpc-membership-payment-form': MembershipPaymentForm,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
    'bpc-display-field-badge': DisplayFieldBadge,
    'bpc-display-field-code': DisplayFieldCode,
    'bpc-display-contact-link': DisplayContactLink,
  },
})
export default class PaymentList extends Vue {
  declare $refs: {
    softDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    bulkSolfDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
  };
  // PROPS
  @Prop({ type: Object }) readonly initialFilters: {
    search: string;
    membership_category_id: number;
    contact_id: number;
    status: string;
  };
  @Prop(Object) readonly membershipCategory: MembershipCategory;
  @Prop({ type: String }) readonly actionsPortalTarget: string;
  @Prop({ type: Boolean }) readonly showMembershipCategoryFilter: boolean;
  @Prop({ type: Boolean }) readonly withUrlParams: boolean;

  // DATA
  moment: any; // NOTE make moment pipe work with typescript
  loading: boolean = false;
  loadingAccounting: boolean = false;
  urlParams: Record<string, string> = {};
  config: BPCDisplayConfig = null;
  paymentItems: Payment[] = [];

  submittedSearch = '';
  selectedContacts = [];
  selectedStatus = '';
  selectedMembershipCategory = null;

  pageOptions: number[] = [5, 10, 15, 20, 50, 100, 200];
  pagination: PaginationInterface = {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    from: 0,
    to: 0,
    total: 0,
  };

  gridCols: object = {
    sm: 12,
    md: 6,
    lg: 4,
  };

  showDrawerSection = false;
  bulkCreate = false;
  formModel: Partial<Payment> = null;
  timestamp = moment().unix();

  // MOVE to TRASH
  showPaymentBulkMoveToTrashModal = false;
  selection = [];
  filterModel = null;
  entityName = 'payment';
  dataToShowInBulkReports = [];
  checkedAllEntities = false;
  searchAndOrderQueryParams = {};

  paymentFieldsToShow = [
    {
      key: 'code',
      headerLabel: 'global.payment.code.header_label',
    },
    {
      key: 'contact.fullname',
      headerLabel: `global.payment.contact_id.label`,
    },
    {
      key: 'paid_amount',
      headerLabel: 'global.payment.paid_amount.header_label',
    },
    {
      key: 'payment_date',
      headerLabel: 'global.payment.payment_date.header_label',
    },
    {
      key: 'payment_method_type',
      headerLabel: 'global.payment.payment_method_type.header_label',
    },
    {
      key: 'status',
      headerLabel: `global.status.label`,
    },
  ];
  // LIFECYCLE

  // created() {}
  mounted() {
    this.initializeFiltersFromProperties();
    this.initializeValuesFromUrlParams();
    this.getPaymentsIfStopChanging();
  }
  // updated(){}
  // destroyed(){}

  // COMPUTED
  get formCancelPortalTarget(): string {
    return `payment-form-cancel-portal-target-${this.timestamp}`;
  }

  get formClosePortalTarget(): string {
    return `payment-form-close-portal-target-${this.timestamp}`;
  }

  get formActionsPortalTarget(): string {
    return `payment-form-actions-portal-target-${this.timestamp}`;
  }

  get filtersConfig() {
    return paymentFilters;
  }
  get displayConfig() {
    return paymentDisplayFields;
  }

  get changeDetectorStr(): string {
    return [
      this.pagination.per_page,
      this.pagination.current_page,
      this.submittedSearch,
      ...this.selectedContacts,
      this.selectedStatus,
    ].join('--');
  }

  get noLabel() {
    // TODO initialize correctly the "for" attribute in field-wrapper
    return {
      labelAttributes: {
        for: 'test',
      },
    };
  }

  get softDeleteConfirmationModalConfig(): ConfirmationModalConfig {
    const entityName = 'membership';
    return {
      id: entityName + '-soft-delete-modal',
      title: this.$t('global.modals.soft-delete.title', {
        entityName: this.$t('global.models.' + entityName + '.name'),
        entityPluralName: this.$t('global.models.' + entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + entityName + '.thisPluralName'),
      }),
      body: this.$t('global.modals.soft-delete.body', {
        entityName: this.$t('global.models.' + entityName + '.name'),
        entityPluralName: this.$t('global.models.' + entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + entityName + '.thisPluralName'),
      }) as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.move_to_trash') as string,
      acceptButtonVariant: 'danger',
    };
  }

  get selectionCount(): number {
    return (this.checkedItems || []).length;
  }

  get trashFilterSelected(): boolean {
    return this.selectedStatus === 'trash';
  }

  // METHODS
  clickOnEdit(data) {
    this.bulkCreate = false;
    this.formModel = data.item.invoice;
    this.formModel = {
      ...data.item,
      payment_method_type: data.item.payment_method_type_value,
    };
    this.showDrawerSection = true;
  }

  clickOnShow(data) {
    this.bulkCreate = false;
    this.formModel = data.item;
    this.showDrawerSection = true;
  }

  onCheckAll(val: boolean) {
    this.checkedAllEntities = val;
  }

  get checkedItems(): Payment[] {
    return this.paymentItems.filter(item => item['checked']);
  }

  initializeFiltersFromProperties() {
    if (this.initialFilters) {
      this.submittedSearch = this.initialFilters?.search || '';
      this.selectedStatus = this.initialFilters?.status || 'paid';
      this.selectedMembershipCategory = this.initialFilters?.membership_category_id || null;
      if (this.initialFilters?.contact_id) {
        if (Array.isArray(this.initialFilters?.contact_id)) {
          this.selectedContacts = this.initialFilters?.contact_id;
        } else {
          this.selectedContacts = [this.initialFilters?.contact_id];
        }
      } else {
        this.selectedContacts = [];
      }
    }
  }

  initializeValuesFromUrlParams() {
    if (this.withUrlParams) {
      const urlParams = this.getUlrParams();
      if (this.submittedSearch) {
        this.submittedSearch = urlParams?.search || '';
      }
      if (!this.selectedStatus) {
        this.selectedStatus = urlParams?.status || 'paid';
      }
      if (!this.selectedMembershipCategory) {
        this.selectedMembershipCategory = urlParams?.membership_category_id || null;
      }

      if (!this.selectedContacts) {
        if (urlParams?.contact_id) {
          if (Array.isArray(urlParams?.contact_id)) {
            this.selectedContacts = urlParams?.contact_id;
          } else {
            this.selectedContacts = [urlParams?.contact_id];
          }
        } else {
          this.selectedContacts = [];
        }
      }
    }
  }

  getPaymentsIfStopChanging() {
    const changeStr = this.changeDetectorStr;
    setTimeout(() => {
      if (changeStr === this.changeDetectorStr) {
        this.getPayments();
      }
    }, 300);
  }

  // First call
  async getPayments() {
    this.loading = true;
    this.checkedAllEntities = false;
    this.loadingAccounting = true;
    const params = this.getQueryParams();
    const url = this.$bpcApiRouteHelper.getEntityPath('payment');
    const res = await this.$bpcApi.get(url, { params: params }).toPromise();
    this.paymentItems = res.data;
    this.pagination = res.meta;
    this.setUrlParams(params);
    this.loading = false;
  }

  getQueryParams() {
    return {
      order_by: 'code',
      order_direction: 'desc',
      per_page: this.pagination.per_page,
      page: this.pagination.current_page,
      search: this.submittedSearch,
      membership_category_id: this.selectedMembershipCategory,
      contact_id: this.selectedContacts,
      status: this.selectedStatus,
    };
  }

  getUlrParams() {
    const urlQueryParams = JSON.parse(JSON.stringify(this.$route.query), (k, v) => {
      if (!isNaN(v) && !isNull(v)) {
        return parseInt(v);
      }
      return v;
    });
    return {
      ...urlQueryParams,
    };
  }

  setUrlParams(params) {
    if (this.withUrlParams) {
      this.$router.push({ query: params }).catch(e => {
        return null;
      });
    }
  }

  clickOnReload() {
    this.getPaymentsIfStopChanging();
  }

  clickOnCreate() {
    // this.bulkCreate = false;
    // this.formModel = {
    //   subscription_category_id: this.selectedMembershipCategory,
    //   price: this.membershipCategory?.price || 0,
    //   status: 'ongoing',
    // };
    // this.showDrawerSection = true;
  }

  clickOnQuickEdit(item) {
    this.bulkCreate = false;
    this.formModel = item;
    this.showDrawerSection = true;
  }

  clickOnSoftDelete(item) {
    this.$refs.softDeleteConfirmationModal.onOpenModal(item.id);
  }
  clickOnBulkSoftDelete() {
    const ids = this.checkedItems.map(item => item.id);
    this.$refs.bulkSolfDeleteConfirmationModal.onOpenModal(ids);
  }

  onEntitySaved() {
    this.$emit('entity-saved');
    this.getPaymentsIfStopChanging();
  }

  onPaymentSaved() {
    this.$emit('entity-saved');
  }

  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.getPaymentsIfStopChanging();
  }
  onSuccessBulkSoftDelete() {
    this.$refs.bulkSolfDeleteConfirmationModal.onCloseModal();
    this.getPaymentsIfStopChanging();
  }

  onCloseModal() {
    this.formModel = null;
    this.showDrawerSection = false;
  }

  clickOnBulkMoveToTrash() {
    this.selection = this.checkedItems.map(item => item.id);
    this.filterModel = this.getQueryParams();
    this.dataToShowInBulkReports = [['code']];
    this.searchAndOrderQueryParams = this.getQueryParams();
    this.showPaymentBulkMoveToTrashModal = true;
  }

  onCLoseBulkSoftDelete() {
    this.showPaymentBulkMoveToTrashModal = false;
    this.getPaymentsIfStopChanging();
  }

  paymentCanBeEdited(payment) {
    return payment.manual || (payment.origin && payment.origin === 'manual');
  }
  paymentCanBeDeleted(payment) {
    return payment.manual || (payment.origin && payment.origin === 'manual');
  }
  // WATCHERS

  @Watch('changeDetectorStr')
  onChangeDetectorStrChange(val) {
    if (val) {
      this.getPaymentsIfStopChanging();
    }
  }
}
